// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyDGdTnsPurt48xECCj6VSuoWzDAylvBYTo',
    authDomain: 'clientpanalprod-8c66a.firebaseapp.com',
    databaseURL: 'https://clientpanalprod-8c66a.firebaseio.com',
    projectId: 'clientpanalprod-8c66a',
    storageBucket: 'clientpanalprod-8c66a.appspot.com',
    messagingSenderId: '600250945604'
  }
};



// WEBPACK FOOTER //
// C:/Users/hassa/Desktop/clientpanel-final/clientpanel_final/src/environments/environment.ts